import React from 'react'
import Link from 'gatsby-link'
import './footer.scss';
import fb from './../../../static/icons/facebook.svg'
import instagram from './../../../static/icons/instagram.svg'

const Footer = () => (
  <footer className="footer">
    <nav className="footer__navigation">
      <div className="footer__social">
        <div className="footer__social-title">FOLLOW US!</div>
        <div className="footer__social-wrapper">
          <a className="footer__social-link" href="https://www.facebook.com/autokwix/">
            <img className="footer__social-img" alt="fb-icon" src={fb} alt="facebook-icon" width="25" height="25" />
          </a>
          <a className="footer__social-link" href="https://www.instagram.com/autokwix/">
            <img className="footer__social-img" alt="insta-icon" src={instagram} alt="instagram-icon" width="25" height="25" />
          </a>
        </div>
      </div>
      <ul className="footer__list">
        <li className="footer__item">
          <Link className="footer__link" to="/about/">
            About me
          </Link>
        </li>
        <li className="footer__item">
          <Link className="footer__link" to="/amazon-affiliate/">
            Amazon Affiliate Disclosure
          </Link>
        </li>
        <li className="footer__item">
          <Link className="footer__link" to="/contact/">
            Contact
          </Link>
        </li>
        <li className="footer__item">
          <Link className="footer__link" to="/privacy-policy/">
            Privacy Policy
          </Link>
        </li>
      </ul>
      <div className="footer__secondary">
        <span className="footer__copyright">Copyright © 2020 · autokwix.com, All Rights Reserved.</span>

        <span>
          <a
            href="//www.dmca.com/Protection/Status.aspx?ID=3bf111a8-baa5-4ce0-851d-a9931c3fcaa9"
            title="DMCA.com Protection Status"
            className="dmca-badge"
          >
            <amp-img
              alt="DMCA.com Protection Status"
              src="https://images.dmca.com/Badges/dmca_protected_sml_120n.png?ID=3bf111a8-baa5-4ce0-851d-a9931c3fcaa9"
              width="121"
              height="21"
              layout="flex-item">
            </amp-img>
          </a>
          <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
        </span>
      </div>
    </nav>
  </footer>
);

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js